import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';
import { deleteCatalogoCobro } from "./CatalogoCobroAction";
import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

/*
const handleClick = (props, id) => {

    swal({
        title: "¿Borrar Servicio?",
        icon: "warning",
        buttons: ["Cancelar!", "SI!"],
        dangerMode: false,
    })
    .then((willDelete) => {
        if (willDelete) {
            console.log("----------->"+props.getCatalogoCobroBorrar);
            props.dispatch(deleteCatalogoCobro(id))
            console.log("----------->" + props.getCatalogoCobroBorrar);
            //props.history.push("/crearcatalogocobro");
            props.history.push("/servicio2");
        } else {
            swal("OK, ¡No será borrado!");
        }
    });
}
*/

const defaultSorted = [
    {
        dataField: "idcatalogocobro",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");
    debugger;

    return {
        getCatalogoCobroList: state.CatalogoCobroReducer.getCatalogoCobroList,
        errorCatalogoCobroList: state.CatalogoCobroReducer.errorCatalogoCobroList,
        getCatalogoCobroBorrar: state.CatalogoCobroReducer.getCatalogoCobroBorrar,
        errorCatalogoCobroBorrar: state.CatalogoCobroReducer.errorCatalogoCobroBorrar,
        getCatalogoCobroActivar: state.CatalogoCobroReducer.getCatalogoCobroActivar,
        errorCatalogoCobroActivar: state.CatalogoCobroReducer.errorCatalogoCobroActivar,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }


const CatalogoCobroTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    const columns = [
        {
            dataField: "idcatalogocobro",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { width: "5%", color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombre",
            text: "Nombre Servicio",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "precio",
            text: "Precio",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "tipo",
            text: "Tipo",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "abrir",
            text: "Vigente",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            headerFormatter: headFormatter
        },
        {
            dataField: "link",
            text: "",
            formatter: (rowContent, row) => {
                return (
                    <div>
                        {
                            
                            (row.activo === true) ? (
                                <>
                                    {
                                        /*
                                         <Link to={"detallecatalogocobro/" + row.idcatalogocobro}>
                                        <button type="button" className="btn btn-icon btn-sm" title="View"><i className="fa fa-eye-slash"></i></button>
                                    </Link>
                                         */
                                    }

                                    <Link to={"borrarcatalogocobro/" + row.idcatalogocobro}>
                                        <button type="button" className="btn btn-icon btn-sm" title="Inactivar"><i className="fa fa-eye-slash text-danger"></i></button>
                                    </Link>
                                </>
                            ) : (
                                    <Link to={"activarcatalogocobro/" + row.idcatalogocobro}>
                                        <button type="button" className="btn btn-icon btn-sm" title="Activar"><i className="fa fa-eye"></i></button>
                                    </Link>
                                )
                        }

                        <Link to={"editarcatalogocobro/" + row.idcatalogocobro}>
                            <button type="button" className="btn btn-icon btn-sm" title="Editar"><i className="fa fa-edit"></i></button>
                        </Link>

                    </div>
                );
            },
        },
    ];


    var total = props.getCatalogoCobroList.length;

    /*
    if (props.getCatalogoCobroBorrar) {
        swal({
            title: "¡Servicio Borrado!",
            icon: "success",
            button: "Enterado"
        })
        .then((willDelete) => {
            props.history.push("/servicios");
        });
    } 
    */

    return (

        <Container>

            {
                props.getCatalogoCobroList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idcatalogocobro"
                        data={props.getCatalogoCobroList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    keyField="idcatalogocobro"
                                    {...props.baseProps}
                                    
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                (
                    <div className="text-center">
                        {props.errorCatalogoCobroList ? (
                            <h4>{props.errorCatalogoCobroList}</h4>
                        ) : (
                                <Spinner color="dark" />
                            )}
                    </div>
                )
           }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(CatalogoCobroTabla));

